module.exports = __webpack_public_path__ + "img/loading-ripple.2cc1b76f.svg";